import React from 'react';
import { Skeleton } from '@mui/material';
import { Container, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ArrowBackOutlined, ArrowForwardOutlined } from '@mui/icons-material';
import useCollectorIntermediateStyles from './hooks/useCollectorIntermediateStyles';

const useStyles = makeStyles((theme) => ({
  ZTLogo: {
    width: theme.spacing(20),
    height: theme.spacing(25)
  },
  collectorLogo: {
    width: theme.spacing(20),
    height: theme.spacing(25),
    marginLeft: theme.spacing(7)
  },
  upperText: {
    width: theme.spacing(80)
  },
  lowerText: {
    width: theme.spacing(33)
  }
}));

export const CollectorIntermediatePageSkeleton: React.FC = () => {
  const {
    root,
    containerRow,
    containerCol,
    arrowIconBack,
    arrowIconForward,
    textContainer
  } = useCollectorIntermediateStyles();
  const { ZTLogo, collectorLogo, upperText, lowerText } = useStyles();
  return (
    <div className={root}>
      <Container className={textContainer}>
        <Typography variant="h3">
          <Skeleton className={upperText} />
        </Typography>
      </Container>
      <Container className={containerRow}>
        <Skeleton className={ZTLogo} />
        <div className={containerCol}>
          <ArrowBackOutlined className={arrowIconForward} />
          <ArrowForwardOutlined className={arrowIconBack} />
        </div>
        <Skeleton className={collectorLogo} />
      </Container>
      <Container className={textContainer}>
        <Typography variant="h5">
          <Skeleton className={upperText} />
        </Typography>
        {window.location.pathname === '/collector/uninstall/success' ||
        window.location.pathname === '/collector/install/success' ? (
          <Typography variant="h5" align="center">
            <b>Please do not close this window.</b>
          </Typography>
        ) : (
          <Typography variant="h5">
            <Skeleton className={lowerText} />
          </Typography>
        )}
      </Container>
    </div>
  );
};
